import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MaintenanceService {
  private serviceUnavailableSubject = new BehaviorSubject<boolean>(false);
  private connectionProblemSubject = new BehaviorSubject<boolean>(!navigator.onLine);

  serviceUnavailable$ = this.serviceUnavailableSubject.asObservable();
  connectionProblem$ = this.connectionProblemSubject.asObservable();

  constructor() {
    window.addEventListener('online', () => {
      this.connectionProblemSubject.next(false);
      this.serviceUnavailableSubject.next(false);
    });
    window.addEventListener('offline', () => {
      this.connectionProblemSubject.next(true);
      this.serviceUnavailableSubject.next(false);
    });
  }

  setServiceUnavailable(state: boolean) {
    this.serviceUnavailableSubject.next(state);
  }

  setConnectionProblem(state: boolean) {
    this.connectionProblemSubject.next(state);
  }

  get isConnectionProblem(): boolean {
    return this.connectionProblemSubject.value;
  }
}
